import { render, staticRenderFns } from "./DocDisplayLogic.vue?vue&type=template&id=5676423c&scoped=true"
import script from "./DocDisplayLogic.vue?vue&type=script&lang=js"
export * from "./DocDisplayLogic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5676423c",
  null
  
)

export default component.exports